module.exports = __webpack_public_path__ + "img/product3.eff1d71d.jpg";